/* Girnar Darshan — theme behaviour. No dependencies. */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function toast(msg){
    var t = document.getElementById('gdToast');
    if (!t) return;
    t.textContent = msg; t.classList.add('gd-on');
    window.clearTimeout(t._h);
    t._h = window.setTimeout(function(){ t.classList.remove('gd-on'); }, 2200);
  }

  /* ---------- hero ---------- */
  function initHero(root){
    if (root.dataset.gdReady === '1') return;
    root.dataset.gdReady = '1';
    var slides = root.querySelectorAll('[data-gd-htrack] .gd-hs');
    if (!slides.length) return;
    var n = root.querySelector('[data-gd-hn]'),
        tot = root.querySelector('[data-gd-htot]'),
        bar = root.querySelector('[data-gd-hbar]'),
        prev = root.querySelector('[data-gd-hprev]'),
        next = root.querySelector('[data-gd-hnext]'),
        count = root.querySelector('[data-gd-hcount]');
    var i = 0, timer = null;
    var delay = (parseInt(root.dataset.autoplay, 10) || 7) * 1000;
    var thumbs = root.querySelectorAll('[data-gd-hgo]');
    thumbs.forEach(function(t){ t.addEventListener('click', function(){ go(parseInt(t.dataset.gdHgo,10)); restart(); }); });
    if (tot) tot.textContent = pad(slides.length);
    if (!count && !n && !bar && slides.length < 2) return;
    if (slides.length < 2 && count) count.style.display = 'none';

    function pad(x){ return x < 10 ? '0' + x : '' + x; }
    function go(k){
      i = (k + slides.length) % slides.length;
      Array.prototype.forEach.call(slides, function(s, m){ s.classList.toggle('gd-on', m === i); });
      if (n) n.textContent = pad(i + 1);
      if (bar) bar.style.width = ((i + 1) / slides.length * 100) + '%';
      thumbs.forEach(function(t, n){ t.classList.toggle('gd-on', n === i); });
      root.classList.remove('gd-tone-new','gd-tone-best','gd-tone-slow');
      var cur = slides[i];
      if (cur.classList.contains('gd-is-best')) root.classList.add('gd-tone-best');
      else if (cur.classList.contains('gd-is-slow')) root.classList.add('gd-tone-slow');
      else root.classList.add('gd-tone-new');
    }
    function start(){ if (!reduced && slides.length > 1) timer = window.setInterval(function(){ go(i + 1); }, delay); }
    function stop(){ window.clearInterval(timer); }
    function restart(){ stop(); start(); }

    if (next) next.addEventListener('click', function(){ go(i + 1); restart(); });
    if (prev) prev.addEventListener('click', function(){ go(i - 1); restart(); });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', function(){ document.hidden ? stop() : restart(); });

    var x0 = null;
    root.addEventListener('touchstart', function(e){ x0 = e.touches[0].clientX; stop(); }, {passive:true});
    root.addEventListener('touchend', function(e){
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 45) go(dx < 0 ? i + 1 : i - 1);
      x0 = null; start();
    });
    go(0); start();
  }

  /* ---------- quotes ---------- */
  function initQuotes(root){
    if (root.dataset.gdReady === '1') return;
    root.dataset.gdReady = '1';
    var qs = root.querySelectorAll('[data-gd-qtrack] .gd-qq');
    if (!qs.length) return;
    var nav = root.querySelector('[data-gd-qnav]');
    var i = 0, timer = null;
    var delay = (parseInt(root.dataset.interval, 10) || 8) * 1000;
    var dots = [];
    if (nav && qs.length > 1){
      nav.innerHTML = '';
      Array.prototype.forEach.call(qs, function(q, k){
        var b = document.createElement('button');
        b.type = 'button'; b.setAttribute('aria-label', 'Quote ' + (k + 1));
        b.addEventListener('click', function(){ go(k); restart(); });
        nav.appendChild(b); dots.push(b);
      });
    }
    function go(k){
      i = (k + qs.length) % qs.length;
      Array.prototype.forEach.call(qs, function(q, m){ q.classList.toggle('gd-on', m === i); });
      dots.forEach(function(d, m){ d.classList.toggle('gd-on', m === i); });
    }
    function start(){ if (!reduced && qs.length > 1) timer = window.setInterval(function(){ go(i + 1); }, delay); }
    function stop(){ window.clearInterval(timer); }
    function restart(){ stop(); start(); }
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    go(0); start();
  }

  /* ---------- mega menu ---------- */
  function initMega(wrap){
    if (wrap.dataset.gdReady === '1') return;
    wrap.dataset.gdReady = '1';
    var triggers = wrap.querySelectorAll('[data-gd-mega]');
    var panels = wrap.querySelectorAll('[data-gd-mega-panel]');
    function close(){ Array.prototype.forEach.call(panels, function(p){ p.classList.remove('gd-on'); }); }
    Array.prototype.forEach.call(triggers, function(t){
      t.addEventListener('mouseenter', function(){
        close();
        var p = wrap.querySelector('[data-gd-mega-panel="' + t.dataset.gdMega + '"]');
        if (p) p.classList.add('gd-on');
      });
      t.addEventListener('focus', function(){ t.dispatchEvent(new Event('mouseenter')); });
    });
    wrap.addEventListener('mouseleave', close);
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape') close(); });
  }

  /* ---------- product page ---------- */
  function initProduct(root){
    if (root.dataset.gdReady === '1') return;
    root.dataset.gdReady = '1';
    root.querySelectorAll('[data-gd-thumb]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var main = document.getElementById('gdMainImage');
        if (main) main.src = btn.dataset.gdThumb;
      });
    });
  }



  /* ---------------- mobile menu ---------------- */
  function initBurger(){
    var b = document.querySelector('[data-gd-burger]');
    var nav = document.querySelector('.gd-topnav');
    if (!b || !nav || b.dataset.gdReady === '1') return;
    b.dataset.gdReady = '1';
    b.addEventListener('click', function(){
      var open = nav.classList.toggle('gd-open');
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }


  /* ---------------- scroll reveal + image fade ---------------- */
  function initMotion(scope){
    var root = scope || document;
    if (reduced) {
      root.querySelectorAll('img').forEach(function(i){ i.classList.add('gd-loaded'); });
      return;
    }

    // mark what should animate in
    root.querySelectorAll('.gd-sechead').forEach(function(el){ el.classList.add('gd-rv-watch'); });
    root.querySelectorAll('.gd-cgrid,.gd-gal,.gd-cats,.gd-vgrid,.gd-arow,.gd-rvs,.gd-bulktiers,.gd-tr')
        .forEach(function(el){ el.classList.add('gd-rv-stagger','gd-rv-watch'); });
    root.querySelectorAll('.gd-offer,.gd-bulk,.gd-fest .gd-festin,.gd-addons,.gd-vcard')
        .forEach(function(el){ el.classList.add('gd-rv-up','gd-rv-watch'); });
    // trust badges, payment chips and product guarantees animate on entry
    root.querySelectorAll('.gd-tr,.gd-pay,.gd-pguar')
        .forEach(function(el){ el.classList.add('gd-rv-watch'); });

    if (!('IntersectionObserver' in window)) {
      root.querySelectorAll('.gd-rv-watch').forEach(function(el){ el.classList.add('gd-in'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting){ e.target.classList.add('gd-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    root.querySelectorAll('.gd-rv-watch').forEach(function(el){ io.observe(el); });

    // fade images in once they have actually decoded
    root.querySelectorAll('.gd-itm img,.gd-cat img,.gd-pimg img').forEach(function(img){
      if (img.complete) { img.classList.add('gd-loaded'); }
      else { img.addEventListener('load', function(){ img.classList.add('gd-loaded'); }, { once: true });
             img.addEventListener('error', function(){ img.classList.add('gd-loaded'); }, { once: true }); }
    });
  }

  function bumpCart(){
    document.querySelectorAll('[data-gd-cart-count]').forEach(function(el){
      el.classList.remove('gd-bump');
      void el.offsetWidth;          // restart the animation
      el.classList.add('gd-bump');
    });
  }

  /* ---------------- video ---------------- */
  function initVideo(){
    document.addEventListener('click', function(e){
      var btn = e.target.closest('[data-gd-play]');
      if (!btn) return;
      var wrap = btn.closest('.gd-video');
      if (!wrap) return;

      // YouTube / Vimeo: swap the poster for an iframe only now
      if (wrap.dataset.gdEmbed){
        var id = wrap.dataset.gdEmbed, host = wrap.dataset.gdHost;
        var src = host === 'vimeo'
          ? 'https://player.vimeo.com/video/' + id + '?autoplay=1&title=0&byline=0'
          : 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0';
        var f = document.createElement('iframe');
        f.src = src; f.title = 'Video'; f.allow = 'autoplay; encrypted-media; picture-in-picture';
        f.setAttribute('allowfullscreen','');
        f.loading = 'lazy';
        wrap.appendChild(f);
        wrap.classList.add('gd-playing');
        return;
      }

      // Shopify-hosted: play with controls
      var v = wrap.querySelector('video');
      if (v){
        v.controls = true;
        v.play();
        wrap.classList.add('gd-playing');
      }
    });
  }

  /* product gallery: image and video thumbs */
  function initMediaThumbs(root){
    var stage = root.querySelector('[data-gd-pmedia]');
    if (!stage) return;
    var store = root.querySelector('.gd-pvideos');

    root.querySelectorAll('[data-gd-thumb]').forEach(function(b){
      b.addEventListener('click', function(){
        stage.innerHTML = '<img id="gdMainImage" src="' + b.dataset.gdThumb + '" alt="">';
      });
    });

    root.querySelectorAll('[data-gd-thumb-video]').forEach(function(b){
      b.addEventListener('click', function(){
        if (!store) return;
        var src = store.querySelector('[data-gd-videosrc="' + b.dataset.gdThumbVideo + '"]');
        if (src) stage.innerHTML = src.innerHTML;
      });
    });

    root.querySelectorAll('[data-gd-thumb-embed]').forEach(function(b){
      b.addEventListener('click', function(){
        var id = b.dataset.gdThumbEmbed, host = b.dataset.gdHost;
        var src = host === 'vimeo'
          ? 'https://player.vimeo.com/video/' + id + '?autoplay=1'
          : 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0';
        stage.innerHTML = '<div class="gd-video gd-playing" style="aspect-ratio:1/1">'
          + '<iframe src="' + src + '" title="Video" allow="autoplay; encrypted-media" allowfullscreen loading="lazy"></iframe></div>';
      });
    });
  }

  /* ---------- cart quantity stepper ---------- */
  /* Changes go through /cart/change.js rather than submitting the form.
     The old version clicked the hidden Update button, which meant clicking
     Checkout blurred the quantity field, fired `change`, and submitted an
     update instead — so checkout appeared to do nothing. */
  function rootUrl(){
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  var cartBusy = false;
  function changeLine(line, qty, btn){
    if (cartBusy) return;
    cartBusy = true;
    if (btn) btn.disabled = true;
    fetch(rootUrl() + 'cart/change.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ line: line, quantity: qty })
    })
      .then(function(r){ if (!r.ok) throw new Error('change failed'); return r.json(); })
      .then(function(){ window.location.reload(); })
      .catch(function(){
        cartBusy = false;
        if (btn) btn.disabled = false;
        toast('Could not update the cart');
      });
  }

  function initCart(){
    document.addEventListener('click', function(e){
      var b = e.target.closest('[data-gd-qminus],[data-gd-qplus]');
      if (b){
        e.preventDefault();
        var step = b.closest('[data-gd-qstep]');
        var input = step && step.querySelector('input');
        var line = step && parseInt(step.dataset.gdLine, 10);
        if (!input || !line) return;
        var cur = parseInt(input.value, 10) || 0;
        var max = parseInt(input.getAttribute('max'), 10);
        var next = b.hasAttribute('data-gd-qplus') ? cur + 1 : cur - 1;
        if (next < 0) next = 0;
        if (!isNaN(max) && next > max){ toast('Only ' + max + ' in stock'); return; }
        input.value = next;
        changeLine(line, next, b);
        return;
      }

      var add = e.target.closest('[data-gd-addon]');
      if (add){
        e.preventDefault();
        add.disabled = true; add.textContent = 'Adding...';
        fetch(rootUrl() + 'cart/add.js', {
          method: 'POST',
          headers: {'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({ id: add.dataset.gdAddon, quantity: 1 })
        }).then(function(r){ if(!r.ok) throw new Error('add failed'); window.location.reload(); })
          .catch(function(){ add.disabled = false; add.textContent = 'Add'; toast('Could not add'); });
      }
    });

    /* Typing a quantity commits on Enter or on blur — but never while a
       submit button is being pressed, which is what broke checkout. */
    var pressingSubmit = false;
    document.addEventListener('pointerdown', function(e){
      if (e.target.closest('button[type="submit"], a')) pressingSubmit = true;
    }, true);
    document.addEventListener('pointerup', function(){
      window.setTimeout(function(){ pressingSubmit = false; }, 300);
    }, true);

    document.addEventListener('change', function(e){
      var input = e.target;
      if (!input.closest || !input.closest('[data-gd-qstep]')) return;
      if (input.tagName !== 'INPUT') return;
      if (pressingSubmit) return;
      var step = input.closest('[data-gd-qstep]');
      var line = parseInt(step.dataset.gdLine, 10);
      var qty = parseInt(input.value, 10);
      if (!line || isNaN(qty) || qty < 0) return;
      changeLine(line, qty, null);
    });

    /* collection sort */
    document.addEventListener('change', function(e){
      if (e.target.matches && e.target.matches('[data-gd-sort]')){
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', e.target.value);
        window.location.href = url.toString();
      }
    });
  }

  /* ---------- voice search ---------- */
  /* Web Speech API. Chrome, Edge and Android Chrome support it; Safari and
     Firefox do not, so the button stays hidden there rather than failing. */
  function initVoiceSearch(){
    var btn = document.querySelector('[data-gd-mic]');
    if (!btn) return;
    var SR = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SR) return;                       // unsupported: leave it hidden
    btn.hidden = false;

    var form = btn.closest('form');
    var input = form && form.querySelector('input[type="search"]');
    if (!input) return;

    var rec = new SR();
    rec.lang = document.documentElement.lang || 'en-IN';
    rec.interimResults = false;
    rec.maxAlternatives = 1;
    var listening = false;

    btn.addEventListener('click', function(){
      if (listening){ rec.stop(); return; }
      try { rec.start(); } catch(e){ return; }
    });
    rec.onstart = function(){ listening = true; btn.classList.add('gd-listening'); input.placeholder = 'Listening...'; };
    rec.onend = function(){ listening = false; btn.classList.remove('gd-listening'); input.placeholder = 'Search the shop'; };
    rec.onerror = function(){ listening = false; btn.classList.remove('gd-listening'); input.placeholder = 'Search the shop'; };
    rec.onresult = function(e){
      var said = e.results && e.results[0] && e.results[0][0] && e.results[0][0].transcript;
      if (!said) return;
      input.value = said.replace(/[.,!?]$/, '');
      form.submit();
    };
  }

  /* ---------- quick add from cards ---------- */
  function initQuickAdd(){
    document.addEventListener('submit', function(e){
      var form = e.target.closest('.gd-quickadd');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('button'), label = btn ? btn.textContent : '';
      if (btn){ btn.disabled = true; btn.textContent = 'Adding...'; }
      fetch(rootUrl() + 'cart/add.js', {
        method: 'POST',
        headers: {'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({ id: form.querySelector('[name="id"]').value, quantity: 1 })
      })
      .then(function(r){ if (!r.ok) throw 0; return fetch(rootUrl() + 'cart.js'); })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        document.querySelectorAll('[data-gd-cart-count]').forEach(function(el){ el.textContent = cart.item_count; });
        if (btn){ btn.textContent = 'Added'; }
        bumpCart();
        toast('Added to cart');
        window.setTimeout(function(){ if (btn){ btn.textContent = label; btn.disabled = false; } }, 1600);
      })
      .catch(function(){ if (btn){ btn.textContent = label; btn.disabled = false; } form.submit(); });
    });
  }

  function boot(scope){
    var s = scope || document;
    s.querySelectorAll('[data-gd-hero]').forEach(initHero);
    s.querySelectorAll('[data-gd-quotes]').forEach(initQuotes);
    s.querySelectorAll('[data-gd-nav]').forEach(initMega);
    s.querySelectorAll('[data-gd-product]').forEach(initProduct);
    s.querySelectorAll('[data-gd-product]').forEach(initMediaThumbs);
    initMotion(s === document ? document : s);
  }
  document.addEventListener('DOMContentLoaded', function(){ boot(); initCart(); initQuickAdd(); initVideo(); initBurger(); initVoiceSearch(); });
  document.addEventListener('shopify:section:load', function(e){ boot(e.target); });
})();
